import { Box, Button, Typography } from "@mui/material";

import heroImage from "../../../static/images/nam_universal_ii/nam-universal-ii-amplifier-placeholder.webp";
import teaserVideo from "../../../static/videos/nam_universal_ii/nam-universal-ii-teaser.mp4";

const NAMUniversalIIFrontpageTile = () => (
  <Box
    sx={{
      position: "relative",
      width: "100%",
      height: "100%",
      minHeight: { xs: "480px", md: 0 },
      overflow: "hidden",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "center",
      textAlign: "center",
      isolation: "isolate",
    }}
  >
    <img
      src={heroImage}
      alt=""
      aria-hidden="true"
      loading="eager"
      fetchpriority="high"
      style={{
        position: "absolute",
        inset: 0,
        zIndex: -3,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        objectPosition: "center",
        backgroundColor: "black",
        pointerEvents: "none",
      }}
    />
    <Box
      component="video"
      aria-hidden="true"
      tabIndex={-1}
      muted
      autoPlay
      playsInline
      loop
      preload="metadata"
      poster={heroImage}
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: -2,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        objectPosition: "center",
        backgroundColor: "black",
        pointerEvents: "none",
        "@media (prefers-reduced-motion: reduce)": {
          display: "none",
        },
      }}
    >
      <source src={teaserVideo} type="video/mp4" />
    </Box>
    <Box
      aria-hidden="true"
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: -1,
        backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.04) 30%, rgba(0, 0, 0, 0.88) 100%)",
        pointerEvents: "none",
      }}
    />
    <Box sx={{ p: { xs: 3, md: 2 }, pb: { xs: 5, md: 3 } }}>
      <Typography
        variant="h3"
        sx={{ fontSize: { xs: 30, md: 30 }, fontWeight: 600 }}
      >
        NAM Universal II
      </Typography>
      <Typography
        sx={{ mt: 1, fontSize: { xs: 17, md: 20 }, letterSpacing: "0.08em", textTransform: "uppercase" }}
      >
        Coming soon
      </Typography>
      <Button
        component="a"
        href="/product/nam-universal-ii"
        aria-label="Learn more about NAM Universal II"
        sx={{
          mt: 3,
          width: { xs: "75%", md: "150px" },
          background: "white",
          color: "black",
          textDecoration: "none",
        }}
        variant="outlined"
      >
        Learn More<span className="sr-only"> about NAM Universal II</span>
      </Button>
    </Box>
  </Box>
);

export default NAMUniversalIIFrontpageTile;
